"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _Theme = require("../Theme");

var __jsx = _react["default"].createElement;

// import { responsiveValueTransformScales } from "../index";
var _default = function _default(_ref) {
  var _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "containerMargin" : _ref$margin,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["sx", "margin"]);
  var theme = (0, _Theme.useTheme)(); // margin =
  //   responsiveValueTransformScales(
  //     margin,
  //     theme,
  //     "containerMargins",
  //     "space"
  //   ) || "10vw";

  return __jsx(_Box["default"], (0, _extends2["default"])({
    sx: (0, _objectSpread2["default"])({}, sx, {
      position: "relative",
      pl: margin,
      pr: margin
    })
  }, restProps));
};

exports["default"] = _default;